import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { RouterLink } from '@/components/functional/Link/RouterLink';
import { CheckCircleOutlineGrayIcon, RemoveCircleOutlineRedIcon, RemoveGrayIcon, } from '@/components/ui/SvgIcon/Static/SvgIconComponents';
import { Text } from '@/components/ui/Typography/Body/Text';
import { IconTextGroup } from '@/components/ui/Typography/IconText/IconTextGroup';
import { clientRfpOneRedirectPath } from '@/utils/router/links';
const icons = {
    draft: RemoveGrayIcon,
    interview: RemoveCircleOutlineRedIcon,
    notInterview: RemoveGrayIcon,
    ordered: CheckCircleOutlineGrayIcon,
    sendOff: RemoveGrayIcon,
};
const text = {
    draft: _jsx(_Fragment, { children: "\u4E0B\u66F8\u304D" }),
    interview: _jsx(_Fragment, { children: "\u672A\u767B\u9332" }),
    notInterview: _jsx(_Fragment, { children: "\u9762\u8AC7\u524D" }),
    ordered: _jsx(_Fragment, { children: "\u767A\u6CE8\u6E08" }),
    sendOff: _jsx(_Fragment, { children: "\u898B\u9001\u308A" }),
};
export const RfpClientStatus = (props) => {
    const { className = '', id, status } = props;
    const Icon = icons[status];
    const textSize = 'sm';
    return (_jsxs(IconTextGroup, Object.assign({ className: className, isInline: true, isVertical: true }, { children: [_jsx(Icon, { size: 'lg' }), status === 'interview' ? (_jsx(RouterLink, Object.assign({ to: clientRfpOneRedirectPath(id) }, { children: _jsx(Text, Object.assign({ className: clsx('underline', 'group-hover:cursor-pointer'), color: 'error', size: textSize }, { children: text.interview })) }))) : (_jsx(Text, Object.assign({ className: 'text-center', color: 'inactive', size: textSize }, { children: text[status] })))] })));
};
export const rfpClientStatusKeys = Object.keys(text);
